// src/components/ImmoAddPage/ImageUploader.jsx

import expandIcon from '@/assets/icons/expand.png';
import trashIcon from '@/assets/icons/trash.png';
import styles from './ImageUploader.module.css';

const handleEnlargeImage = (url) => window.open(url, "_blank");

const ImageUploader = ({ formData, setFormData }) => {
  const handleRemoveImage = (index) => {
    setFormData((prev) => {
      const newUrls = [...prev.imagesUrls];
      if (newUrls[index] === prev.mainImageUrl) {
        const newMain = newUrls.filter((_, i) => i !== index)[0] || "";
        return { ...prev, imagesUrls: newUrls.filter((_, i) => i !== index), mainImageUrl: newMain };
      }
      newUrls.splice(index, 1);
      return { ...prev, imagesUrls: newUrls };
    });
  };

  const handleRemoveNewImage = (index) => {
    setFormData((prev) => {
      const newImages = [...prev.images];
      newImages.splice(index, 1);
      return { ...prev, images: newImages };
    });
  };

  const defineMainImage = (url) => {
    setFormData((prev) => ({ ...prev, mainImageUrl: url }));
  };

  return (
    <div>
      {/* Images existantes */}
      {formData.imagesUrls?.length > 0 && (
        <div>
          <h4>Images existantes</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {formData.imagesUrls.map((url, index) => (
              <div className={styles.imageContainer} key={index}>
                <img src={url} alt={`Aperçu ${index}`} className={styles.imagePreview} />
                <div className={styles.iconsContainer}>
                  <button type="button" onClick={() => handleRemoveImage(index)} className={styles.iconDelete}>
                    <img src={trashIcon} alt="Supprimer" />
                  </button>
                  <button type="button" onClick={() => handleEnlargeImage(url)} className={styles.iconEnlarge}>
                    <img src={expandIcon} alt="Agrandir" />
                  </button>
               <button
  type="button"
  onClick={() => defineMainImage(url)}
  className={`${styles.iconSetMain} ${formData.mainImageUrl === url ? styles.active : ""}`}
>
  {formData.mainImageUrl === url ? "Principale ✔" : "Définir principale"}
</button>

                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Nouvelles images */}
      {formData.images?.length > 0 && (
        <div>
          <h4>Nouvelles images</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {formData.images.map((file, index) => {
              const localUrl = URL.createObjectURL(file);
              return (
                <div className={styles.imageContainer} key={index}>
                  <img src={localUrl} alt={`Aperçu ${index}`} className={styles.imagePreview} />
                  <div className={styles.iconsContainer}>
                    <button type="button" onClick={() => handleRemoveNewImage(index)} className={styles.iconDelete}>
                      <img src={trashIcon} alt="Supprimer" />
                    </button>
                    <button type="button" onClick={() => handleEnlargeImage(localUrl)} className={styles.iconEnlarge}>
                      <img src={expandIcon} alt="Agrandir" />
                    </button>
                    <button type="button" onClick={() => defineMainImage(localUrl)} className={styles.iconSetMain}>
                      {formData.mainImageUrl === localUrl ? "Principale ✔" : "Définir principale"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUploader;
